import { useContext,FC } from 'react'
import axios, { AxiosHeaders } from 'axios'
import { AuthContext } from '../Contexts/AuthContext';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authConfig'

export const axiosInstance = axios.create();

const setInterceptor = (token:string): void => {

    const authorization = `Bearer ${token}`;
    axiosInstance.interceptors.request.use(
        async config => {
            config.baseURL = process.env.REACT_APP_ORGINPICK_URL
            //config.baseURL = 'https://localhost:44375/'
            config.headers = new AxiosHeaders({
                Authorization: `${authorization}`,
            })
            return config;
        },
        error => {
            throw error;
        });
}

export const request = ({ ...options }) => {
    const onSuccess = (response: any) => {
        return response
    }
    const onError = (error: any) => {
        return error
    }
    return axiosInstance(options).then(onSuccess).catch(onError);
}

const WithAxios:FC<any> = ({ children }) => {
    const authContext = useContext(AuthContext);
    const { instance } = useMsal();
    
    const account = instance.getActiveAccount();
        if (account) {
            instance.acquireTokenSilent(loginRequest).then((response) => {
                authContext.login(response.accessToken)
                authContext.token = response.accessToken
                setInterceptor(response.accessToken)
                //setUserRole(account)
            }).catch((e) => {
                instance.acquireTokenPopup(loginRequest).then((response) => {
                    authContext.token = response.accessToken
                    //setUserRole(account)
                });
            });
        }

    return children
}

export default WithAxios
